<template>
  <div>
    <div class="pittan">
      <img src="@/assets/img/アセット 64@3x.png" @click="openModal" />
    </div>
    <div class="overlay" v-show="showContent">
      <img class="confirm-bg" src="@/assets/img/アセット 80@3x.png" />
      <img class="confirm-msg" src="@/assets/img/アセット 81@3x.png" />
      <img
        class="confirm-yes"
        src="@/assets/img/アセット 82@3x.png"
        @click="submission"
      />
      <img
        class="confirm-no"
        src="@/assets/img/アセット 83@3x.png"
        @click="closeModal"
      />
    </div>
    <div class="first-success overlay" v-show="pittanMedal">
      <img v-if="medal_type === 'gold'" class="medal-style" src="@/assets/img/アセット 87@3x.png"/>
      <img v-else-if="medal_type === 'silver'" class="medal-style" src="@/assets/img/アセット 85@3x.png" />
      <img v-else class="medal-style" src="@/assets/img/アセット 86@3x.png" />
    </div>

    <div v-show="mistakeactive" class="mistake-msg">
      <p>矢印の箇所が間違っています。<br />もう一度やってみましょう！</p>
      <img
        v-show="downArrow1"
        class="down-arrow1"
        src="@/assets/img/アセット 84@3x.png"
      />
      <img
        v-show="downArrow2"
        class="down-arrow2"
        src="@/assets/img/アセット 84@3x.png"
      />
      <img
        v-show="downArrow3"
        class="down-arrow3"
        src="@/assets/img/アセット 84@3x.png"
      />
      <img
        v-show="downArrow4"
        class="down-arrow4"
        src="@/assets/img/アセット 84@3x.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["isActive1", "isActive2", "isActive3", "isActive4", "judgment1", "judgment2", "judgment3", "judgment4", "mistakeactive"],
  data() {
    return {
      downArrow1: false,
      downArrow2: false,
      downArrow3: false,
      downArrow4: false,
      showContent: false,
      pittanMedal: false,
      medal_type: String,
      correctAnswerFlag1: false,
      correctAnswerFlag2: false,
      number_to_completion: 0,
      result_flg: 0,
      firstPittan: true,
    };
  },
  methods: {
    openModal() {
      this.$emit('stopmusic');
      if (
        this.isActive1 !== null &&
        this.isActive2 !== null &&
        this.isActive3 !== null &&
        this.isActive4 !== null
      ) this.showContent = true;
    },
    closeModal() {
      this.showContent = false;
    },
    submission() {
      this.$store.commit("SET_ISPITTAN", true);
      if (
        this.judgment1 === 1 &&
        this.judgment2 === 2 &&
        this.judgment3 === 3 &&
        this.judgment4 === 4
      ) {
        this.closeModal();
        if(this.number_to_completion === 0)this.result_flg = 1;
        this.number_to_completion += 1

        if(this.firstPittan){
        this.$emit('submission');
        this.firstPittan = false
        } else {
          this.updatePlaysApi()
        }

        this.showPittanMedal()
        setTimeout(this.TransitionToHistory, 10000);
      } else {
        this.closeModal();
        this.resetDownArrow()
        this.mistakeactive = true;
        setTimeout(()=>{
          this.mistakeactive = false;
        }, 5000);
        this.number_to_completion += 1

        if(this.firstPittan){
        this.$emit('submission');
        this.firstPittan = false
        } else {
          this.updatePlaysApi()
        }

        if (this.judgment1 === 1) {
          const dropzone1 = document.getElementById("dropzone1");
          dropzone1.style.zIndex = 60;
          this.correctAnswerFlag1 = true
          this.$emit('eventname1', this.correctAnswerFlag1)
        } else {
          this.downArrow1 = true;
        }
        if (this.judgment2 === 2) {
          const dropzone2 = document.getElementById("dropzone2");
          dropzone2.style.zIndex = 60;
          this.correctAnswerFlag2 = true
          this.$emit('eventname2', this.correctAnswerFlag2)
        } else {
          this.downArrow2 = true;
        }
        if (this.judgment3 === 3) {
          const dropzone3 = document.getElementById("dropzone3");
          dropzone3.style.zIndex = 60;
          this.correctAnswerFlag3 = true
          this.$emit('eventname3', this.correctAnswerFlag3)
        } else {
          this.downArrow3 = true;
        }
        if (this.judgment4 === 4) {
          const dropzone4 = document.getElementById("dropzone4");
          dropzone4.style.zIndex = 60;
          this.correctAnswerFlag4 = true
          this.$emit('eventname4', this.correctAnswerFlag4)
        } else {
          this.downArrow4 = true;
        }
      }
      this.$store.commit("FIRST_PITTAN", true);
    },
    async updatePlaysApi() {
      const playId = this.$store.state.playId
      const new_axios = this.axios.create({
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
        responseType: "json",
      });
      const body = {
        "result_flg": this.result_flg,
        "retired_flg": 0,
        "number_to_completion": this.number_to_completion
      };
      const endpoint = process.env.API_ENDPOINT + "/plays/" + playId
      const response = await new_axios
        .put(endpoint, body)
        .then(response => console.log(response))
        .catch(function (error) {
          console.log("エラーだよ", error);
        });
    },
    showPittanMedal() {
      this.correctSound = new Audio();
      this.correctSound.src = require("@/assets/sounds/Quiz-Results02-1.mp3");
      this.correctSound.play();
      if (this.number_to_completion === 1) {
      this.medal_type = 'gold'
      } else if (this.number_to_completion === 2) {
      this.medal_type = 'silver'
      } else {
        this.medal_type = 'copper'
      }
      this.pittanMedal = true
    },
    resetDownArrow(){
      this.downArrow1 = false;
      this.downArrow2 = false;
      this.downArrow3 = false;
      this.downArrow4 = false;
    },
    TransitionToHistory() {
      this.$router.push('/history')//History.vueへ遷移
    }
  },
};
</script>

<style>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 103;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /*画面の中央に要素を表示させる設定*/
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-bg {
  width: 850px;
  position: relative;
  z-index: 50;
}
.confirm-msg {
  width: 400px;
  position: absolute;
  z-index: 51;
  top: 250px;
}
.confirm-yes {
  width: 300px;
  position: absolute;
  z-index: 51;
  top: 350px;
  left: 200px;
}
.confirm-no {
  width: 300px;
  position: absolute;
  z-index: 51;
  top: 350px;
  right: 200px;
}
.pittan {
  position: absolute;
  top: 520px;
  left: 820px;
}
.pittan img {
  width: 135px;
}
.yes-btn {
  float: left;
  margin-left: 100px;
}
.no-btn {
  float: right;
  margin-right: 100px;
}
.mistake-msg {
  z-index: 104;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mistake-msg p {
  font-size: 60px;
  color: #fff;
  font-weight: bold;
}
.mistake-msg img {
  width: 150px;
  animation: move-y 0.5s infinite alternate ease-in-out;
  display: inline-block;
}
@keyframes move-y {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(10px);
  }
}
.mistake-msg .down-arrow1 {
  position: absolute;
  top: 400px;
  left: 215px;
}
.mistake-msg .down-arrow2 {
  position: absolute;
  top: 400px;
  left: 365px;
}
.mistake-msg .down-arrow3 {
  position: absolute;
  top: 400px;
  left: 510px;
}
.mistake-msg .down-arrow4 {
  position: absolute;
  top: 400px;
  left: 655px;
}
.medal-style {
  animation-name: fadeIn;
  animation-duration: 5s;
  width: 550px;
}
@keyframes fadeIn {
  from {
    opacity: 1;
    width: 100px;
  }
  to {
    opacity: 1;
    width: 550px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PittanBtn.vue